<template>
  <div>
    <breadcrumbs :crumbs="[]">
      <div class="folders-breadcrumbs">
        <router-link :to="{name: 'Reports Index', params: {reset: true}}">Reports</router-link>
        <template v-for="breadcrumb, idx in path">
          <a class="folder-path-link" v-if="idx > 0" @click="goToFolder(breadcrumb.id)">
            <i class="fa" :class="{'fa-folder-o' : idx !== path.length-1, 'fa-folder-open-o' : idx === path.length-1 }"></i>{{ breadcrumb.name }}</a><i v-if="idx !== path.length-1" class="fa fa-angle-right"></i>
        </template>
        <i class="fa fa-angle-right"></i>
        <a>Create Report</a>
      </div>
    </breadcrumbs>
    <!-- END PAGE HEADER-->
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="portlet light">
              <div class="portlet-title">
                <div class="caption caption-md">
                  <i class="icon-globe theme-font hide"></i>
                  <span class="caption-subject bold uppercase">Create Report</span>
                </div>
              </div>
              <div class="portlet-body">
                <spinner v-show="loading.edit"/>
                <form role="form" v-show="!loading.edit" class="form-horizontal">
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-6">
                        <form data-vv-scope="add-report">
                          <div class="form-group" :class="{ 'has-error': errors.has('add-report.name') }">
                            <label for="formname">Report Name</label>
                            <input id="formname" class="form-control" placeholder="New Report Name Here" name="name"
                                   type="text" v-validate="'required'" v-model="report.name">
                            <span v-show="errors.has('add-report.name')" class="help-block">{{ errors.first('add-report.name') }}</span>
                          </div>
                          <div class="form-group" :class="{ 'has-error': errors.has('add-report.description') }">
                            <label for="formdesc">Report Description</label>
                            <textarea id="formdesc" class="form-control" placeholder="Description goes here..."
                                      name="description" type="text" v-validate="'required'"
                                      v-model="report.description"></textarea>
                            <span v-show="errors.has('add-report.description')" class="help-block">{{ errors.first('add-report.description') }}</span>
                          </div>

                          <template v-if="showReportTypeSelect">
                            <div class="form-group" :class="{ 'has-error': errors.has('add-report.mode') }">
                              <label for="workingmode">Report Type</label>
                              <select name="workingmode" v-model="report.mode" v-bind:disabled="lockModeChange" @change="reportModeChanged" class="form-control" id="workingmode">
                                <option :value="1">Single organization (default)</option>
                                <option :value="3" v-if="organization.accountType == 'parent'">Single organization, Mirror in Child Accounts</option>
                                <option :value="2">Multiple organizations</option>
                                <option :value="4" v-if="organization.accountType == 'parent'">Multiple organizations, Mirror in Child Accounts</option>
                              </select>
                            </div>

                            <div class="form-group" v-if="[2,3,4].includes(report.mode)" :class="{ 'has-error': errors.has('settings_form.form_accounts') }">
                              <label>Select Organizations</label>

                              <vue-select
                                  v-model="reportAccounts"
                                  :options="multipleOrganizationsList"
                                  label="organizationName"
                                  value="reportAccounts"
                                  :multiple=true
                                  placeholder="All organizations"
                              >
                                <template slot="option" slot-scope="option">
                                  {{ option.organizationName }}
                                </template>
                              </vue-select>

                              <span v-show="errors.has('settings_form.AccessLevel')" class="help-block">{{ errors.first('settings_form.AccessLevel') }}</span>
                            </div>
                          </template>
                        </form>
                      </div>
                    </div>
                  </div>
                  <div class="clearfix"></div>
                  <div class="form-body">
                    <form-wizard @on-complete="onComplete"
                                 title=""
                                 subtitle=""
                                 color="#d09f23"
                                 @on-change="wizardTabChanged"
                    >
                      <tab-content title="Select Form(s)"
                                   icon="fa fa-address-card-o" :before-change="getSelectedFormsFields">
                        <spinner v-show="loading.forms"/>
                        <div class="row" v-if="!loading.forms && !loading.reports">
                          <div class="col-md-6">
                            <div class="list-group">
                              <a class="accordion-toggle list-group-title collapsed" data-toggle="collapse" data-parent="#organization-forms-accordion"
                                 href="#collapse-organization-forms">Organization Forms<i class="fa"></i></a>
                              <div id="collapse-organization-forms" class="collapse">
                                <div class="list-group-item" @click.prevent="addForm(form.id)" v-if="reportSelected(form.id) === undefined" v-for="form in organizationForms">{{ form.name }}</div>
                              </div>
                            </div>

                            <div class="list-group" v-if="showParticipantForms">
                              <a class="accordion-toggle list-group-title collapsed" data-toggle="collapse" data-parent="#participants-forms-accordion"
                                 href="#collapse-participants-forms">{{ participantSingularName }} Forms<i class="fa"></i></a>
                              <div id="collapse-participants-forms" class="collapse">
                                <div class="list-group-item" @click.prevent="addForm(form.id)" v-if="reportSelected(form.id) === undefined" v-for="form in participantForms">{{ form.name }}</div>
                              </div>
                            </div>

                            <div class="list-group" v-if="referralForms.length">
                              <a class="accordion-toggle list-group-title collapsed" data-toggle="collapse" data-parent="#participants-forms-accordion"
                                 href="#collapse-referral-forms">Referral Forms<i class="fa"></i></a>
                              <div id="collapse-referral-forms" class="collapse">
                                <div class="list-group-item" @click.prevent="addForm(form.id)" v-if="reportSelected(form.id) === undefined" v-for="form in referralForms">{{ form.name }}</div>
                              </div>
                            </div>

                          </div>
                          <div class="col-md-6">
                            <div class="list-group">
                              <div class="list-group-item" v-for="(form, idx) in selectedForms" @click.prevent="removeForm(form.form_id)">{{ getFormName(form.form_id) }}</div>
                            </div>
                          </div>
                        </div>
                      </tab-content>

                      <!-- select fields step -->

                      <tab-content title="Select Values" icon="fa fa-keyboard-o" :before-change="getQuery">
                        <spinner v-show="loading.fields"/>
                        <div class="row" v-if="!loading.fields">
                          <div class="col-md-6">

                            <div class="list-group" v-for="form, idx in formFields">
                              <a class="accordion-toggle list-group-title collapsed" data-toggle="collapse" data-parent="#collapse-ff-accordion"
                                 :href="'#collapse_ff_'+idx">{{ form.name }}<i class="fa"></i></a>

                              <div :id="'collapse_ff_'+idx" class="collapse">
                                <div class="list-group-item" @click.prevent="selectedFields.push({id: form.id, form: form.name, field: field.name, label: field.description})"
                                     v-if="exceptions.includes(field.type) && !isSelected(selectedFields, field, form.id) && !field.hideInReports"
                                     v-for="field in form.data">
                                  {{ field.description }}
                                </div>

                                <div class="list-group-item" v-for="field in form.data" v-if="field.type == 'accordion' && !field.hideInReports">{{ field.description }}
                                  <div class="list-group-item" v-for="acc in field.values" @click.prevent="selectedFields.push({id: form.id, form: form.name, field: acc.name, label: acc.description})"
                                       v-if="exceptions.includes(acc.type) && !isSelected(selectedFields, acc, form.id)">{{ acc.description }}
                                  </div>
                                </div>

                                <template v-if="referralFormsModulesKeys.includes(form.module_key)">
                                  <div class="list-group-item"
                                       v-for="field in referralFields"
                                       @click.prevent="selectedFields.push({id: form.id, form: form.name, ...field })"
                                       v-if="!isSelected(selectedFields, {name: field.field, id: form.id}, form.id)">
                                    {{  field.label }}
                                  </div>
                                </template>

                                <div class="list-group-item" @click.prevent="selectedFields.push({id: form.id, form: form.name, field: '_organization_name', label: 'Organization Name' })"
                                     v-if="(form.module == 6 || form.module == 7) && !isSelected(selectedFields, {name: '_organization_name', id: form.id}, form.id)">Organization Name
                                </div>

                                <template v-if="participantFormsModulesKeys.includes(form.module_key) || organizationFormsModulesKeys.includes(form.module_key)">
                                  <div class="list-group-item"
                                       v-for="field in participantFields"
                                       @click.prevent="selectedFields.push({id: form.id, form: form.name, ...field })"
                                       v-if="!isSelected(selectedFields, {name: field.field, id: form.id}, form.id)">
                                    {{  field.label }}
                                  </div>
                                </template>

                                <div class="list-group-item" @click.prevent="selectedFields.push({id: form.id, form: form.name, field: '_casemgr_account', label: 'CaseMGR Account Name' })"
                                     v-if="!isSelected(selectedFields, {name: '_casemgr_account', id: form.id}, form.id)">CaseMGR Account Name
                                </div>

                              </div>
                            </div>

                          </div>

                          <div class="col-md-6">
                            <template class="list-group" v-for="(form, key) in selectedFormsWithSelectedFields">
                              <span class="list-group-title">{{ getFormName(form.form_id) }}</span>
                              <draggable :list="form.fields" tag="ul" class="list-group" @change="updateFieldsList">
                                <li class="list-group-item" v-for="field in form.fields" :key="field.order" @click="removeSelectedField(field.field, form.form_id)"> {{ field.label }}</li>
                              </draggable>
                            </template>
                          </div>

                        </div>
                      </tab-content>
                      <tab-content title="Define Criteria"
                                   icon="fa fa-cogs"
                                   :before-change="getPreview">
                        <div class="row">
                          <div class="col-md-6">
                            <div v-for="form in selectedFormsWithSelectedFields" class="list-group accordion">
                              <a class="accordion-toggle list-group-title collapsed" data-toggle="collapse" data-parent="#criteria-accordion"
                                 :href="'#collapse_f_'+form.form_id">{{ getFormName(form.form_id) }}<i class="fa"></i></a>
                              <div :id="'collapse_f_'+form.form_id" class="collapse">
                                <div class="list-group-item" v-if="form.hasOwnProperty('isNull')">
                                  <label class="margin-bottom-0">Include null values:</label>
                                  <toggle-button :class="'margin-bottom-0'" :sync="true" :labels="true" v-model="form.isNull"/>
                                </div>
                                <div v-for="field in form.fields" class="list-group-item"
                                     :class="{ 'active': field == currentField }" @click="selectField(field)">
                                  {{ field.label }}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6" v-if="currentField">
                            <div class="editBox">
                              <h5>Edit: <b>{{ currentField.label }}</b></h5>
                            </div>
                            <div class="conditions-box">
                              <form>
                                <div class="form-body">
                                  <div class="col-md-12">
                                    <template v-if="getFieldType(currentField.field) === 'ssn'">
                                      <div class="form-group">
                                        <label class="margin-bottom-0">Show full number:</label>
                                        <toggle-button :class="'margin-bottom-0'" :sync="true" :labels="true" v-model="currentField.showFullNumber"/>
                                      </div>
                                    </template>
                                    <template v-if="getFieldType(currentField.field) === 'date'">
                                      <div class="form-group" v-for="(condition, idx) in currentField.conditions">
                                        <i class="fa fa-trash pull-right" @click="removeCondition(idx)" aria-hidden="true" v-if="idx > 0"></i>
                                        <label>Date range:</label>
                                        <select class="form-control" v-model="currentField.conditions[idx].date" @change="clearVal(condition)">
                                          <option value="">Select option...</option>
                                          <option v-for="field in dateConditions" :value="field.type">{{ field.name }}
                                          </option>
                                        </select>

                                        <div v-if="currentField.conditions[idx].date === 'birthmonth'">
                                          <br/>
                                          <label>Month:</label>
                                          <select class="form-control" v-model="currentField.conditions[idx]['value']">
                                            <option value="">Select option...</option>
                                            <option v-for="n in 12" :value="n">{{ n }}
                                            </option>
                                          </select>
                                        </div>

                                        <br/>

                                        <div ref="target"></div>
                                        <date-picker v-if="['lessthan','greaterthan','lessorequal','greaterorequal','between'].includes(currentField.conditions[idx].date) && showPicker"
                                                     v-model="pickerDate"
                                                     :placeholder="format"
                                                     :format="format"
                                                     :value-type="'format'"
                                                     :confirm="false"
                                                     :range="currentField.conditions[idx].date === 'between'"
                                                     prefix-class="xmx"
                                                     lang="en"
                                                     range-separator="-"
                                                     v-on:change="dateSelected"
                                        />

                                        <hr v-if="idx+1 < currentField.conditions.length">
                                      </div>

                                    </template>
                                    <template v-else-if="currentField.field.indexOf('_referral') === -1">

                                      <div class="form-group" v-if="getFieldType(currentField.field) == 'radio' || getFieldType(currentField.field) == 'rating'">
                                        <label>Answer options:</label>
                                        <select class="form-control" v-model="currentField.columns">
                                          <option :value="['label']">Label</option>
                                          <option :value="['value']">Value</option>
                                          <option :value="['label', 'value']">Label and Value</option>
                                        </select>
                                        <hr>
                                      </div>

                                      <div class="form-group" v-for="(condition, idx) in currentField.conditions">
                                        <i class="fa fa-trash pull-right" @click="removeCondition(idx)" aria-hidden="true"></i>
                                        <label>Type:</label>
                                        <select v-model="condition.type" class="form-control" @change="clearVal(condition)">

                                          <option v-for="conditionType in conditionTypes" :value="conditionType.type"> {{conditionType.name}}</option>
                                          <option v-if="!['_creator_id','_editor_id','_casemgr_account','programs'].includes(getFieldType(currentField.field))"
                                                  v-for="conditionType in emptyFilledConditionTypes" :value="conditionType.type"> {{conditionType.name}}
                                          </option>
                                          <option v-if="!['_creator_id','_editor_id','_casemgr_account','programs'].includes(getFieldType(currentField.field))"
                                                  v-for="conditionType in numericConditionTypes" :value="conditionType.type"> {{conditionType.name}}
                                          </option>
                                          <option v-if="!['_creator_id','_editor_id','_casemgr_account','programs'].includes(getFieldType(currentField.field))"
                                                  v-for="conditionType in additionalConditionTypes" :value="conditionType.type"> {{conditionType.name}}
                                          </option>
                                        </select>
                                        <br>
                                        <div v-if="!['unduplicated','between','isempty','isfilled','recent'].includes(condition.type)">
                                          <label>{{ currentField.field.substr(0, currentField.field.indexOf('-')) == 'rating' ? 'Value: ' : 'Label: ' }}</label>
                                          <input type="text" value="" class="form-control"
                                                 v-model="condition.value">
                                          <br>
                                        </div>

                                        <div v-if="condition.type == 'recent'">
                                          <label>Most recent date based on field:</label>
                                          <select v-model="condition.value" class="form-control" @change="onMostRecentConditionSelect(condition, currentField.id)">
                                            <option v-for="dateField in dateFields[currentField.id]" :value="dateField.name"> {{ dateField.description }}</option>
                                            <option value="createdDate">Activity Logging - Completed Date</option>
                                            <option value="updatedDate">Activity Logging - Modified Date</option>
                                          </select>
                                        </div>
                                        <div v-if="['between'].includes(condition.type)">
                                          <label>From</label>
                                          <input type="text" v-model="condition.value[0]" class="form-control">
                                          <br/>
                                          <label>To</label>
                                          <input type="text" v-model="condition.value[1]" class="form-control">
                                        </div>
                                        <hr>
                                      </div>
                                      <div class="form-group" v-if="currentField.conditions.length > 1">
                                        <label>
                                          If
                                          <select v-model="currentField.allConditions">
                                            <option :value="false">Any</option>
                                            <option :value="true">All</option>
                                          </select>
                                          the rules are matched.
                                        </label>
                                      </div>
                                      <div class="form-group margin-bottom-0"
                                           v-if="!['_manager_id','_secondary_manager_id'].includes(getFieldType(currentField.field)) && !isSharedFormPreviewType(currentField.field)">
                                        <button class="btn green" @click.prevent="addNewCondition()">+ Add New Condition</button>
                                      </div>
                                    </template>
                                  </div>
                                </div>
                              </form>
                              <div class="clearfix"></div>
                            </div>
                          </div>
                        </div>
                      </tab-content>
                      <tab-content title="Preview"
                                   icon="fa fa-eye"
                      >
                        <div class="form-body" v-show="!showLoader">
                          <report-table :total-rows="totalRows" :report="reportPreview" :loading="showLoader" @refresh-report="refreshReport"></report-table>
                        </div>
                        <spinner v-show="showLoader"/>
                        <div class="clearfix"></div>
                      </tab-content>
                    </form-wizard>
                  </div>
                </form>
                <div class="clearfix"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
</template>
<script>
  import Breadcrumbs from '@/components/Breadcrumbs'
  import DatePicker from 'vue2-datepicker';
  import Spinner from '@/components/Spinner';
  import {mapActions, mapGetters} from 'vuex';
  import _ from 'lodash';
  import ReportTable from "./ReportTable";
  import VueSelect from 'vue-select'
  import draggable from 'vuedraggable';
  import {getUserInfo} from '@/http-common';
  import fieldTypeUtils from "../../mixins/fieldTypeUtils";
  import reportCommons from "../../mixins/reportCommons";
  import participantDisplayName from '@/mixins/participantDisplayName';

  export default {
    data() {
      return {
        select: [],
        form_query: [],
        currentField: null,
        selectedForms: [],
        selectedFields: [],
        additionalConditionTypes: [
          {
            type: 'unduplicated',
            name: 'unduplicated'
          },
          {
            type: 'recent',
            name: 'most recent'
          }
        ],
        range: ['', ''],
        resultsOffset: 0,
        resultsLimit: 10,
        resultsPerPage: 10,
        totalRows: 0,
        mode: null,
        reportAccounts: [],
        lockModeChange: false,
        reportGenerating: false,
        selectedFormsWithSelectedFields: [],
        dateFormat: 'MM/DD/YYYY',
        cloneInChildOrganizations: false,
        participantFormsModulesKeys: ['participants_profile', 'members_profile', 'participants_contact', 'participants_assignment', 'activities_services', 'assessment_outcomes'],
        organizationFormsModulesKeys: ['organization_organization', 'organization_general'],
        referralFormsModulesKeys: ['individuals_referral', 'members_referral'],
        referralFields: [
          {field: '_referral_status', label: 'Status' },
          {field: '_referral_not_enrolled_reason', label: 'Not Enrolled Reason'},
          {field: '_referral_timestamp_received', label: 'Status Timestamp: Received'},
          {field: '_referral_timestamp_completed', label: 'Status Timestamp: Completed'},
          {field: '_referral_timestamp_not_enrolled', label: 'Status Timestamp: Not Enrolled'},
        ],
        participantFields: [
          {field: '_creator_id', label: 'Completed By'},
          {field: '_creation_date', label: 'Completed At'},
          {field: '_editor_id', label: 'Modified By'},
          {field: '_edition_date', label: 'Modified At'},
          {field: '_manager_id', label: 'Assigned Case Manager'},
          {field: '_secondary_manager_id', label: 'Assigned Case Manager (Secondary)'},
        ],
        showPicker: false,
        pickerDate: null
      }
    },
    mixins: [
      fieldTypeUtils,
      reportCommons,
      participantDisplayName,
    ],
    components: {
      ReportTable,
      DatePicker,
      Breadcrumbs,
      Spinner,
      VueSelect,
      draggable
    },
    inject: {
      $validator: '$validator'
    },
    mounted() {
      this.errors.clear('add-report');
      this.dateFormat = getUserInfo('date_format');

      if (this.$route.params.reportid) {
        this.getReportAction(this.$route.params.reportid);
      } else {
        this.report.mode = 1;
        this.loadForms({
          'mode': this.report.mode,
          'accounts': this.report.accounts
        });
      }
    },
    computed: {
      ...mapGetters({
        user: 'getUser',
        reports: 'getReports',
        report: 'getReport',
        reportPreview: 'getReportPreview',
        forms: 'getFormsInOrder',
        formFields: 'getFieldsReportInOrder',
        loading: 'getReportsLoading',
        userAccounts: 'getUserAccounts',
        account: 'account',
        folder: 'getFolder',
        path: 'getPath',
        organization: 'getOrganization'
      }),
      showLoader() {
        return (this.loading.reports === true) || this.reportGenerating;
      },
      dateFields: function () {
        let dateFields = {};
        _.forEach(this.formFields, function (field) {
          dateFields[field.id] = _.filter(field.data, {'type': 'date'});
        });
        return dateFields;
      },
      format() {
        return getUserInfo('date_format');
      },
      selectedFieldsInForms() {
        let result = [];
        this.selectedForms.map((form) => {
          form.fields = [];
          _.each(this.selectedFields, (field, i) => {
            if (field.id === form.form_id) {
              if (!field.hasOwnProperty('conditions')) {
                if ((field.field.indexOf('radio-group-') !== -1) || (field.field.indexOf('rating-') !== -1)) {
                  this.$set(field, 'columns', ['label']);
                }
                this.$set(field, 'conditions', []);
                this.$set(field, 'allConditions', true);
              }

              if (this.getFieldType(field.field) === 'date') {
                let currentConds = field.conditions;
                if (_.findIndex(field.conditions, function (cond) {
                  return cond.hasOwnProperty('date');
                }) === -1) {
                  currentConds.push({'date': '', 'dateFormat': this.format, 'value': ''});
                  this.$set(field, 'conditions', currentConds);
                }
              }

              this.$set(field, 'order', i+1);
              form.fields.push(field);
            }
          });

          if (form.fields.length === 0) {
            delete (form.fields);
          } else {
            result.push(form)
          }
        });

        return result;
      },
      showReportTypeSelect() {
        return !['child', 'program'].includes(this.organization.accountType);
      },
      multipleOrganizationsList() {
        if (this.organization.accountType === 'child') {
          return []
        }
        if (this.organization.accountType === 'default') {
          return this.userAccounts;
        }
        if (this.organization.accountType === 'parent') {
          let parentOrganization = [{
            id: this.organization.id,
            organizationName: this.organization.name
          }];

          return parentOrganization.concat(this.account.childrenAccounts);
        }
      },
      participantForms() {
        return _.filter(this.forms, (form) => {
          return this.participantFormsModulesKeys.includes(form.module_key);
        });
      },
      organizationForms() {
        return _.filter(this.forms, (form) => {
          return this.organizationFormsModulesKeys.includes(form.module_key);
        });
      },
      referralForms() {
        return _.filter(this.forms, (form) => {
          return this.referralFormsModulesKeys.includes(form.module_key);
        });
      },
      showParticipantForms() {
        return true;
      }
    },
    methods: {
      ...
        mapActions({
          loadForms: 'GET_FORMS_ACTION',
          loadFields: 'GET_FORMS_FIELDS_ACTION',
          addReport: 'ADD_REPORT_ACTION',
          editReport: 'EDIT_REPORT_ACTION',
          getReport: 'GET_REPORT_ACTION',
          getReportAction: 'GET_REPORT_EDIT_ACTION',
          loadUserAccounts: 'loadUserAccounts',
          setFolderIdAction: 'SET_FOLDER_ID_ACTION',
          getAccount: 'GET_ACCOUNT_ACTION'
        }),

      clearVal(el, data) {
        if (el.type == 'between') {
          el.value = ['', ''];
          return;
        }

        if (!['unduplicated', 'between', 'isempty', 'isfilled'].includes(el.type)) {
          el.value = '';
        }

        if (el.value != null) {
          el.value = '';
        }
      },
      removeSelectedField(field, formId) {
        let idx = this.selectedFields.findIndex((el) => {
          return el['field'] == field && parseInt(el['id']) == parseInt(formId)
        });

        this.selectedFields.splice(idx, 1);
      },
      isSelected(data, item, formId) {
        let status = false;
        data.map(obj => {
          if (obj['field'] == item['name'] && formId == obj['id']) {
            status = true;
          }
        });
        return status
      },
      getFormName(form_id) {
        let form = _.find(this.forms, ['id', form_id]);

        if (form !== undefined) {
          return form.name;
        }
        return 'FORM REMOVED';
      },
      wizardTabChanged(prevIndex, nextIndex) {
        if (nextIndex === 0) {
          this.lockModeChange = false;
        }
      },
      getSelectedFormsFields() {
        this.lockModeChange = true;
        return new Promise((resolve, reject) => {
          if (this.selectedForms.length) {
            let formsIds = _.map(this.selectedForms, 'form_id');
            this.loadFields(formsIds);
            resolve(true)
          } else {
            reject();
          }
        });

      },
      getQuery() {
        return new Promise((resolve, reject) => {
          if (this.selectedFields.length) {
            resolve(true)
          } else {
            reject();
          }
        });
      },
      getFieldType(name) {
        if (['_creation_date', '_edition_date'].includes(name)) {
          return 'date'
        }
        const field = name.split('-');
        return field[0]
      },
      onComplete() {
        this.$validator.validateAll('add-report').then((result) => {
          if (result) {
            this.reportGenerating = true;
            if (this.$route.params.reportid) {
              this.editReport({
                id: this.$route.params.reportid,
                data: JSON.stringify(this.selectedFormsWithSelectedFields),
                mode: this.mode,
                accounts: this.reportAccounts,
              })
            } else {
              this.addReport({
                data: this.selectedFormsWithSelectedFields,
                mode: this.mode,
                accounts: this.reportAccounts,
                folderId: this.folder ? this.folder.id : null
              })
            }
          }
        });
      },
      addNewCondition() {
        if (this.getFieldType(this.currentField.field) !== 'date') {
          this.currentField.conditions.push({
            type: '',
            value: ''
          });
        }
      },
      selectField(data) {
        this.currentField = data;
      },
      removeCondition(idx) {
        this.currentField.conditions.splice(idx, 1);
      },
      changeDate() {
        this.getReport({
          report: JSON.stringify(this.selectedFormsWithSelectedFields),
          data: this.range,
          mode: this.mode,
          accounts: this.reportAccounts,
          offset: 0,
          limit: 10
        });
      },
      getPreview() {
        this.getReport({
          report: JSON.stringify(this.selectedFormsWithSelectedFields),
          data: this.range,
          mode: this.mode,
          accounts: this.reportAccounts,
          offset: 0,
          limit: 10
        });
        return new Promise((resolve, reject) => {
          resolve(true);
        });
      },
      addForm(form_id) {
        let form = this.getFormDataById(form_id);
        let formData = {
          'form_id': form.id,
          'form_name': this.getFormName(form.id)
        };

        if (!form.is_core) {
          formData.isNull = false;
        }

        this.selectedForms.push(formData);

        this.reorderForms();
      },
      removeForm(form_id) {
        this.selectedForms = this.selectedForms.filter(function (item) {
          return item.form_id != form_id;
        });
        this.reorderForms();
      },
      reorderForms() {
        this.selectedForms = _.map(this.selectedForms, (item, i) => {
          return _.extend({}, item, {order: i})
        })
      },
      getFormDataById(form_id) {
        return _.find(this.forms, ['id', form_id]);
      },
      reportSelected(form_id) {
        return _.find(this.selectedForms, ['form_id', form_id]);
      },
      updateReport() {
        if (this.report.hasOwnProperty('data')) {
          this.mode = this.report.mode;
          this.reportAccounts = this.report.accounts;
          this.report['data'].map((obj, key) => {
            let formData = {
              'order': obj.order,
              'form_id': obj.form_id,
              'form_name': obj.form_name,
            }

            if (obj.hasOwnProperty('isNull')) {
              formData.isNull = obj.isNull
            }

            this.selectedForms.push(formData);

            this.report['data'][key]['fields'].map(field => {
              let data = {
                id: obj.form_id,
                field: field.field,
                label: field.label,
                conditions: field.conditions,
                allConditions: typeof field.allConditions === "boolean" ? field.allConditions : null,
                columns: field.columns || null,
              }
              if (field.field.startsWith('ssn')){
                data.showFullNumber = field.showFullNumber;
              }
              this.selectedFields.push(data);
            })
          });
        }
      },
      refreshReport(offset, limit, sortBy, sortDir) {
        this.resultsOffset = offset;
        this.resultsLimit = limit;
        this.getReport({
          report: JSON.stringify(this.selectedFormsWithSelectedFields),
          data: this.range,
          mode: this.mode,
          accounts: this.reportAccounts,
          offset: offset,
          limit: limit,
          sortBy: sortBy,
          sortDir: sortDir
        });
      },
      reportModeChanged() {

        if (this.mode == 1 && this.report.mode == 2) {
          this.$notify('Report Type has been modified. Some previously selected forms may be unavailable for the selected Report Type.');
        }

        this.mode = this.report.mode;
        this.loadForms({
          'mode': this.report.mode,
          'accounts': this.report.accounts
        });

        this.refreshReport(this.resultsOffset, this.resultsPerPage);
      },
      updateFieldsList(event) {
        this.$forceUpdate();
      },
      goToFolder(folderId) {
        this.setFolderIdAction(folderId);
        this.$router.push({name: 'Reports Index'});
      },
      onMostRecentConditionSelect(condition, currentFormId) {
        if (condition.value === 'createdDate') {
          condition.label = 'Activity Logging - Completed Date';
          return;
        }

        if (condition.value === 'updatedDate') {
          condition.label = 'Activity Logging - Modified Date';
          return;
        }

        if (condition.value !== '') {
          if (!this.dateFields.hasOwnProperty(currentFormId)) {
            condition.label = '';
            return;
          }

          let field = this.dateFields[currentFormId].find(dateField => dateField.name === condition.value);

          if (field === undefined) {
            condition.label = '';
            return;
          }

          condition.label = field.description;
        }
      },
      dateSelected(evt) {
        this.currentField.conditions[0].value = evt;
      }
    },

    watch: {
      forms: function (newVal) {

        let newFormsIds = [];

        if (newVal.length) {
          newFormsIds = newVal.map(item => {
            return item.id;
          });
        }

        this.selectedForms = this.selectedForms.filter(function (item) {
          return newFormsIds.includes(item.form_id);
        });
      },
      report: function () {
        this.updateReport();
      },
      reportAccounts: function () {
        this.refreshReport(this.resultsOffset, this.resultsPerPage);
      },
      selectedFieldsInForms: {
        deep: true,
        handler(newVal) {
          this.selectedFormsWithSelectedFields = newVal
        }
      },
      mode: function (mode) {
        if ([2, 3, 4].includes(mode)) {
          this.loadUserAccounts();
          this.getAccount(this.organization.id);
        }
      },
      // TODO: check this
      'currentField.conditions': {
        deep: true,
        handler(newVal) {
          newVal.forEach((item, idx) => {
            if (item.hasOwnProperty('date')) {
              this.pickerDate = item.value;
            }
          })

          this.showPicker = false;
          _.delay(() => { this.showPicker = true}, 100);
        }
      },
    }
  }
</script>

<style scoped>
  .ms-container {
    width: 100%;
  }

  .ms-container .ms-list {
    height: 400px;
  }

  .conditions-box {
    border: 1px solid rgba(0, 0, 0, .2);
    padding: 20px;
  }

  .accordion .list-group-item {
    padding: 10px 15px;
    border-color: #ddd;
  }

  .list-group span, .list-group-title {
    width: 100%;
    display: block;
    background: #d09f24;
    color: white;
    font-weight: 600;
    padding: 10px 15px;
  }

  .list-group-title i {
    float: right;
    margin-top: 2px;
  }

  .list-group-item:hover {
    cursor: pointer;
  }

  .list-group-item.active, .list-group-item.active:hover, .list-group-item.active:focus {
    background-color: #d09f24;
    border-color: #d09f24
  }

  .sortable-chosen.sortable-ghost {
    background: #ddd;
  }

  .margin-bottom-0 {
    margin-bottom: 0;
  }

</style>



// WEBPACK FOOTER //
// ReportsAdd.vue?c9ecce5a